module.exports = __webpack_public_path__ + "img/response-documents.6cd08277.svg";